import axios from "axios";
import { useState } from "react";
import { MdSmsFailed } from "react-icons/md";
import { Payment_Retry } from "../../api/api";
import { Link } from "react-router-dom";


const FailedPayment = ({ title, code }) => {

     const [loading, setLoading] = useState(false)


     const handleRetryPayment = async () => {
          try {
               setLoading(true)
               const formData = new FormData();
               formData.append("gateWayTransactionId", code);

               const res = await axios.post(Payment_Retry, formData)
               if (res.data?.redirectLink) window.location.href = res.data.redirectLink

          } catch (error) {
               console.log(error);
               setLoading(false)
          }
     }


     return (
          <>
               <div className="paymentPage failed">
                    <MdSmsFailed />
                    {title && <div className="contentPaid">
                         <h2>{title}</h2>
                         <p>بررسی ما نشان میدهد پرداخت به درستی انجام نشده است و چنانچه مبلغی از حساب شما کسر شده است، طی 72 ساعت آینده به حساب شما بازخواهد گشت.</p>
                    </div>}

                    <div className="flex gap-3">
                         {code && <button className="btnS" onClick={handleRetryPayment} disabled={loading}>{loading ? 'لطفا صبر کنید...' : 'پرداخت مجدد'}</button>}
                         <a className="btnS" href={'https://t.me/STM_WEB'} target="_blank">پشتیبانی تلگرام</a>
                         <Link className="btnS" to={'/'}>بازگشت</Link>
                    </div>
               </div>
          </>
     );
}

export default FailedPayment;